import { Receipt, FileText, Download } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

const invoicePayLabel = (type) => {
  if (type === "deposit") return "Reserva";
  if (type === "full") return "Total";
  return "Final";
};

const downloadInvoice = async (number) => {
  try {
    const res = await api.get(`/admin/invoices/${number}/download`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = `factura-${number}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch {
    toast.error("No se pudo descargar la factura");
  }
};

export default function InvoicesList({ invoices }) {
  if (!invoices || invoices.length === 0) return null;
  return (
    <div className="mt-5 pt-5 border-t border-white/10" data-testid="invoices-section">
      <div className="flex items-center gap-2 mb-3">
        <Receipt className="w-4 h-4 text-[#FFC107]" />
        <span className="text-xs font-mono uppercase tracking-wider text-[#A1A1AA]">Facturas emitidas</span>
      </div>
      <div className="space-y-2">
        {invoices.map((inv) => (
          <button
            key={inv.number}
            onClick={() => downloadInvoice(inv.number)}
            className="w-full flex items-center justify-between gap-3 px-3 py-2.5 rounded-md bg-white/5 hover:bg-[#FFC107]/10 border border-white/10 hover:border-[#FFC107]/30 transition-colors group"
            data-testid={`download-invoice-${inv.number}`}
          >
            <div className="flex items-center gap-3 min-w-0">
              <FileText className="w-4 h-4 text-[#FFC107] flex-shrink-0" />
              <div className="min-w-0 text-left">
                <div className="text-sm font-mono text-white truncate">{inv.number}</div>
                <div className="text-[10px] text-[#71717A] uppercase tracking-wider">
                  {new Date(inv.issued_at).toLocaleDateString("es-ES")} · {invoicePayLabel(inv.payment_type)} · {Number(inv.total).toFixed(2)}€
                </div>
              </div>
            </div>
            <Download className="w-4 h-4 text-[#71717A] group-hover:text-[#FFC107] flex-shrink-0" />
          </button>
        ))}
      </div>
    </div>
  );
}
